export const ONCO_CARE_MAX_AGE = 80;
export const ONCO_CARE_MIN_AGE = 18;
export const ONCO_CARE_CHILD_MIN_AGE = 1;
export const ONCO_CARE_CHILD_MAX_AGE = 21;
